import styled from '@emotion/styled';

const Container = styled.div`
  box-sizing: border-box;
  width: 100%;
  height: auto;
  background: ${({ theme }) => theme.PrimaryActionColorPure};
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

interface SkeletonContainerProps {
  width?: string;
}

const SkeletonContainer = styled.div<SkeletonContainerProps>`
  width: ${({ width }) => width || '100%'};
`;

const S = {
  Container,
  SkeletonContainer,
};

export default S;
